import {required, ValidationResult, Validator} from '@/types/validation/ValidationResult';
import {AuthenticationRequest} from '@/types/authentication/Authentication';

export class SignInChecker {
  result: ValidationResult;

  constructor(result: AuthenticationRequest) {
    const checker = new ValidationResult(SignInValidator);
    checker.validate(result);
    this.result = checker;
  }

  get hasErrors(): boolean {
    return this.result.hasErrors;
  }

  get getMessages(): string[] {
    return this.result.getMessages();
  }
}

export const SignInValidator: Validator[] = [
  {
    name: 'examineeNumber',
    constraints: [
      {method: required, message: '受講者番号を入力してください'},
    ],
  },
  {
    name: 'officeCode',
    constraints: [
      {method: required, message: '支所を選択してください'},
    ],
  },
  {
    name: 'password',
    constraints: [
      {method: required, message: 'パスワードを入力してください'},
    ],
  },
];

